export default __webpack_public_path__ + "abda43730bb53d188df55a77a1251827.png";